export default "__VITE_ASSET__CiPA$Pjr__"